<template>
    <v-container class="pa-0">
        <v-alert
            v-if="
                itemAvailability &&
                ((itemAvailability.isFresh && !text) || text) &&
                !isShopPage
            "
            dense
            :text="text"
            :color="getAlertColor(itemAvailability.alertType)"
            border="left"
        >
            <div
                class="d-flex align-center"
                :style="`color: ${
                    text || itemAvailability.alertType === 'error'
                        ? ''
                        : 'white'
                }`"
            >
                <div>
                    <fa
                        v-if="itemAvailability.alertType === 'error'"
                        :icon="['fal', 'info-circle']"
                        class="fa-lg mr-2"
                    />
                </div>
                <div class="d-inline">
                    <TranslatableStringComponent
                        :tstring="{
                            string: `${itemAvailability.availabilityMessage}`,
                            variables: [
                                {
                                    var: `${convertToReadabledate(
                                        itemAvailability.leadDate
                                    )}`,
                                },
                            ],
                        }"
                    />
                    <a href="tel:+17247757926"
                        ><TranslatableStringComponent
                            v-if="
                                [
                                    'contactForAvailability',
                                    'mcbAvailabilityMessage',
                                ].includes(itemAvailability.availabilityMessage)
                            "
                            :tstring="{ string: 'c3Phone' }"
                    /></a>
                </div>
                <v-btn
                    v-if="text"
                    icon
                    small
                    :loading="availabilityLoading"
                ></v-btn>
            </div>
        </v-alert>
        <v-chip
            v-if="itemAvailability && itemAvailability.isFresh && isShopPage"
            :class="{
                'text-wrap': true,
                'on-error': [
                    'contactForAvailability',
                    'mcbAvailabilityMessage',
                ].includes(itemAvailability.availabilityMessage),
                'justify-center': true,
            }"
            style="width: 100%"
            :color="getAlertColor(itemAvailability.alertType)"
            small
            ><div class="d-inline">
                <TranslatableStringComponent
                    :tstring="{
                        string: `${itemAvailability.availabilityMessage}`,
                        variables: [
                            {
                                var: `${convertToReadabledate(
                                    itemAvailability.leadDate
                                )}`,
                            },
                        ],
                    }"
                />
                <a href="tel:+17247757926"
                    ><TranslatableStringComponent
                        v-if="
                            [
                                'contactForAvailability',
                                'mcbAvailabilityMessage',
                            ].includes(itemAvailability.availabilityMessage)
                        "
                        :tstring="{ string: 'c3Phone' }"
                /></a></div
        ></v-chip>
    </v-container>
</template>
<script>
import { mapGetters } from 'vuex'
import TranslatableStringComponent from './TranslatableStringComponent.vue'
export default {
    name: 'AlertForRealTimeInventory',
    components: {
        TranslatableStringComponent,
    },
    props: {
        text: {
            type: Boolean,
            default: false,
        },
        itemAvailability: {
            type: Object,
            default: undefined,
        },
        loading: {
            type: Boolean,
            default: false,
        },
        isShopPage: {
            type: Boolean,
            default: false,
        }
    },
    computed: {
        ...mapGetters({
            availabilityLoading:
                'realTimeInventoryData/fetchAvailabilityLoadingState',
        }),
        alertColor() {
            if (this.itemAvailability) {
                switch (this.itemAvailability.alertType) {
                    case 'error':
                        return '#a63446'
                    case 'success':
                        return '#06a77d'
                    case 'warning':
                        return '#efa00b'
                }
            } else return '#0063a6'
        },
        alertTextColor() {
            if (
                this.itemAvailability.alertType === 'warning' ||
                this.itemAvailability.alertType === 'success'
            ) {
                return '#ffffff'
            } else {
                return '#000000'
            }
        },
    },
    methods: {
        convertToReadabledate(isoDate) {
            return isoDate
                ? new Intl.DateTimeFormat('en-US').format(new Date(isoDate))
                : null
        },
        getAlertColor(alertType) {
            switch (alertType) {
                case 'warning':
                    return 'warning'
                case 'success':
                    return 'success'
                case 'error':
                    return this.text ? 'primary' : 'default'
                default:
                    break
            }
        },
    },
}
</script>
<style lang="scss" scoped>
.v-alert {
    padding-top: 0;
    padding-bottom: 0;
    margin-bottom: 0;
    margin-top: 0.5em;
}
.v-chip.v-size--small {
    border-radius: 4px;
    font-size: 10px;
    padding: 2px 4px;
}
.v-chip.on-error {
    height: 50px;
}
.v-chip {
    line-height: 12px;
}
</style>
